import SvgIcon from "../svg-icon";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import store from "../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../actions/global-actions";
import associateServices from "../../services";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import SvgIconExternal from "../svg-icon-external";
import {show} from "@intercom/messenger-js-sdk";
import stringHelper from "../../helpers/string-helper";
import {useTranslation} from "react-i18next";

const SidebarSmall = (props) => {

    const {active} = props
    const {languages, configuration, activeLanguage} = useSelector(state => state.globalReducer)
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const {i18n} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language
    const [searchParams, setSearchParams] = useSearchParams()


    const location = useLocation();
    const navigate = useNavigate();
    const handleUpdateLanguage = language => {
        store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(language.key))
        if (authenticated)
            associateServices.setLanguage({
                language: language?.key
            }).then(null)

        // Build the new path with the selected language
        const pathSegments = location.pathname.split('/');
        pathSegments[1] = language.key; // Set the new language segment
        const newPath = pathSegments.join('/');

        // Navigate to the new path
        navigate(newPath);

    }

    const handleLiveSupport = () => {
        try {

           if (window?.Comm100API) {
                try {
                    console.log('window?.Comm100API = ', window?.Comm100API)
                    window?.Comm100API?.open_chat_window();
                } catch (e) {
                    console.error(e)
                }
            } else {
                show()

            }
        } catch (e) {
            console.error(e)
            alert(e.message)
        }
    }

    const [races, setRaces] = useState([])
    const [raffles, setRaffles] = useState([])

    useEffect(() => {
        associateServices.getPromotions({
            language: activeLanguage?.key
        }).then(res => {
            setRaces(res?.data?.races || [])
            setRaffles(res?.data?.raffles || [])
        })
    }, [activeLanguage?.key])

    return (
        <>
            <div className="sidebar__small">

                <div className="sidebar__links-small">
                    <Link to={stringHelper.getLocalizedPath(currentLanguage, '/casino')}
                          style={{
                              background: `url(${configuration?.casino_bg}) no-repeat left center/cover`
                          }}
                          className={`sidebar__link-small sidebar__link-small--purple ${active === 'sportsbook' ? 'passive' : ''}`}/>


                    <Link
                        to={stringHelper.getLocalizedPath(currentLanguage, '/sportsbook')}
                        style={{
                            background: `url(${configuration?.sportsbook_bg}) no-repeat left center/cover`
                        }}
                        className={`sidebar__link-small sidebar__link-small--purple ${active === 'casino' ? 'passive' : ''}`}/>


                </div>

                <ul className="sidebar__nav-small sidebar__nav-small--border">
                    <li className={active === 'homepage' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/')}
                        >
                            <SvgIcon id={'homepage'}/>
                        </Link>
                    </li>
                    <li className={active === 'vip' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/vip')}
                        >
                            <SvgIcon id={'vip'}/>
                        </Link>
                    </li>

                    <li className={active === 'challenges' ? 'active' : ''}>
                        <Link to={stringHelper.getLocalizedPath(currentLanguage, '/challenges')}>
                            <SvgIcon id={'challenge'}/>
                        </Link>
                    </li>

                    {
                        configuration?.stream_enabled &&
                        <li className={active === 'streams' ? 'active' : ''}>
                            <Link to={stringHelper.getLocalizedPath(currentLanguage, '/streams')}>
                                <SvgIcon id={'stream'}/>
                            </Link>
                        </li>
                    }


                    <li className={active === 'blog' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/blog')}

                        >
                            <SvgIcon id={'blog'}/>
                        </Link>
                    </li>

                    <li className={active === 'casino' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/casino')}

                        >
                            {/*// onClick={e => handleNavigation('/casino')}>*/}
                            <SvgIcon id={'casino2'}/>
                        </Link>
                    </li>

                    {
                        configuration?.trade_able &&
                        <li className={active === 'trade' ? 'active' : ''}>
                            <Link
                                to={stringHelper.getLocalizedPath(currentLanguage, '/trade')}
                            >
                                <SvgIcon id={'chart'}/>
                            </Link>
                        </li>
                    }


                </ul>


                <ul className="sidebar__nav-small sidebar__nav-small--border">


                    <li className={active === 'slots' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/casino/slots')}
                        >
                            {/*onClick={e => handleNavigation('/casino/slots')}>*/}
                            <SvgIcon id={'slots2'}/>
                        </Link>
                    </li>


                    <li className={active === 'live-casino' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/live-casino')}
                        >
                            {/*onClick={e => handleNavigation('/casino/group/live-casino')}>*/}
                            <SvgIcon id={'live-casino'}/>
                        </Link>
                    </li>

                    <li className={active === 'sportsbook' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/sportsbook')}
                        >
                            <SvgIcon id={'sportsbook2'}/>
                        </Link>
                    </li>

                    <li className={active === 'exclusive' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/casino/category/exclusive')}
                        >
                            <SvgIcon id={'exclusive'}/>
                        </Link>
                    </li>


                    <li className={active === 'virtual-sports' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/casino/virtual_sports')}
                        >
                            <SvgIcon id={'virtual-sports'}/>
                        </Link>
                    </li>


                    {
                        authenticated &&
                        <li className={active === 'settings' ? 'active' : ''}>
                            <Link
                                to={stringHelper.getLocalizedPath(currentLanguage, '/settings')}
                            >
                                <SvgIcon id={'profile'}/>
                            </Link>
                        </li>
                    }


                    <li>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, '/tournaments')}
                        >
                            <SvgIcon id={'tournaments'}/>
                        </Link>
                    </li>

                    {
                        races?.map(race => (
                            <li key={race?.uuid}>
                                <Link
                                    to={stringHelper.getModalPathRace('race', race.uuid, searchParams)}
                                >
                                    <SvgIcon id={'75'}/>
                                </Link>
                            </li>
                        ))
                    }


                    {
                        raffles?.map(raffle => (
                            <li key={raffle?.uuid}>
                                <Link
                                    to={stringHelper.getModalPathRace('raffle', raffle.uuid, searchParams)}
                                >
                                    <SvgIcon id={'75'}/>
                                </Link>
                            </li>
                        ))
                    }


                </ul>


                <ul className="sidebar__nav-small sidebar__nav-small--border">
                    <li>
                        <button onClick={handleLiveSupport}>
                            <SvgIcon id={'headset'}/>
                        </button>
                    </li>
                    <li className={active === 'policy' ? 'active' : ''}>
                        <Link
                            to={stringHelper.getLocalizedPath(currentLanguage, `/policy`)}
                        >
                            <SvgIcon id={'shield'}/>
                        </Link>
                    </li>
                </ul>


                <div className="sidebar__actions-small">
                    <div className="sidebar__lang-small">
                        <a
                            className="sidebar__lang-small-btn"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <SvgIconExternal icon={activeLanguage.flag}/>
                            {/*<SvgIcon id={activeLanguage?.key}/>*/}
                        </a>
                        <ul className="dropdown-menu sidebar__lang-small-menu">
                            {
                                languages?.map(language => (
                                    <li key={language.key}>
                                        <button onClick={e => handleUpdateLanguage(language)}>
                                            <SvgIconExternal icon={language.flag}/>
                                            {/*<SvgIcon id={language.key}/>*/}
                                            <span>
                                            </span>
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>


                    {
                        configuration?.has_temes &&
                        <div className="sidebar__scheme-small">
                            <button type="button" className="active" data-bs-theme-value="dark">
                                <SvgIcon id={'light-mode'}/>
                            </button>
                            <button type="button" data-bs-theme-value="light">
                                <SvgIcon id={'dark-mode'}/>
                            </button>
                        </div>
                    }


                </div>

            </div>


        </>

    )


}

export default SidebarSmall
